import { render, staticRenderFns } from "./PeopleSelected.vue?vue&type=template&id=6fd1bd26&scoped=true&"
import script from "./PeopleSelected.vue?vue&type=script&lang=js&"
export * from "./PeopleSelected.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSelected.vue?vue&type=style&index=0&id=6fd1bd26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd1bd26",
  null
  
)

export default component.exports